import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type React from 'react';
import { NAVY } from 'styles/tokens';

interface PageTitleProps {
  children: React.ReactNode;
  /** Optional subtitle rendered below the title in muted body text. */
  subtitle?: React.ReactNode;
  /** Overrides the outer Box margin (default: mb: 2). */
  sx?: SxProps<Theme>;
}

/**
 * Standardized page-level title component.
 * Enforces consistent variant, color, font, and spacing across all pages.
 * Change styles here to affect every page at once.
 */
const PageTitle: React.FC<PageTitleProps> = ({ children, subtitle, sx }) => (
  <Box sx={{ mt: 2, mb: 2, ...sx }}>
    <Typography
      variant="h4"
      color={NAVY}
      sx={{
        fontFamily: 'Jost, sans-serif',
        fontWeight: 600,
        ml: { xs: 6, sm: 10, md: 0 },
      }}
    >
      {children}
    </Typography>
    {subtitle && (
      <Typography
        variant="body1"
        sx={{
          color: 'text.secondary',
          ml: { xs: 6, sm: 10, md: 0 },
          mt: 0.5,
        }}
      >
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default PageTitle;
